import api from '../../utils/helpers/api'

type ResponType = {
  data: any
  meta?: object
  status?: boolean
}

const suratPernyataan = {
  /**
   * Generate/Preview PDF Surat Pernyataan (tanpa simpan)
   * POST /api/v1/pana/surat-pernyataan-penerima-beasiswa
   */
  previewSurat: async (): Promise<ResponType> => {
    return (await api.post('/pana/surat-pernyataan-penerima-beasiswa', {})) as Promise<ResponType>
  },

  /**
   * Simpan Surat (generate + QR code)
   * POST /api/v1/pana/save-surat-pernyataan-penerima-beasiswa
   */
  saveSurat: async (isSetuju: number = 1): Promise<ResponType> => {
    return (await api.post('/pana/save-surat-pernyataan-penerima-beasiswa', {
      is_setuju: isSetuju,
    })) as Promise<ResponType>
  },

  /**
   * Download PDF untuk dibubuhi materai
   * GET /api/v1/pana/download-surat-pernyataan-penerima-beasiswa
   * Response: File binary/blob
   */
  downloadSurat: async (): Promise<any> => {
    return await api.get('/pana/download-surat-pernyataan-penerima-beasiswa', {
      responseType: 'blob',
    })
  },

  /**
   * Upload surat yang sudah diberi materai
   * POST /api/v1/pana/upload-surat-pernyataan-penerima-beasiswa-bermaterai
   */
  uploadSuratBermaterai: async (file: File): Promise<ResponType> => {
    const formData = new FormData()
    formData.append('upload_file', file)

    return (await api.post(
      '/pana/upload-surat-pernyataan-penerima-beasiswa-bermaterai',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )) as Promise<ResponType>
  },

  /**
   * Preview surat bermaterai yang sudah diupload
   * GET /api/v1/pana/download-surat-pernyataan-penerima-beasiswa-bermaterai
   * Response: File binary/blob atau base64
   */
  previewSuratBermaterai: async (): Promise<any> => {
    return await api.get('/pana/download-surat-pernyataan-penerima-beasiswa-bermaterai', {
      responseType: 'blob',
    })
  },
}

export default suratPernyataan
